export const ORDER_METHOD = {
  TAKE_OUT: 'TAKE_OUT',
  EAT_IN: 'EAT_IN',
  DELIVERY: 'DELIVERY',
} as const;

export const orderMethod = {
  [ORDER_METHOD.TAKE_OUT]: 'テイクアウト',
  [ORDER_METHOD.EAT_IN]: '店内飲食',
  [ORDER_METHOD.DELIVERY]: 'デリバリー',
} as const;

export const orderMethods = [
  {
    value: ORDER_METHOD.TAKE_OUT,
    name: orderMethod.TAKE_OUT,
  },
  {
    value: ORDER_METHOD.EAT_IN,
    name: orderMethod.EAT_IN,
  },
  {
    value: ORDER_METHOD.DELIVERY,
    name: orderMethod.DELIVERY,
  },
];

export type OrderMethod = keyof typeof orderMethod;
